// Domain Models
import { EmployeeScheduleService } from ".";

// Utils
import { isEmpty } from "../../../utils";

const mapServices = src =>
  !isEmpty(src) ? src.map(service => new EmployeeScheduleService(service)) : null;

const extractRole = worker => {
  if (worker.role) return worker.role;
  if (Array.isArray(worker.roles) && worker.roles.length > 0) {
    const r = worker.roles[0];
    return { id: r.id, name: r.name };
  }
  if (worker.user_role && worker.user_role.role) {
    return { id: worker.user_role.role.id, name: worker.user_role.role.name };
  }
  return null;
};

export class WorkerSchedule {
  constructor(worker = {}) {
    this.id = worker.id;
    this.firstName = worker.first_name || worker.firstName;
    this.lastName = worker.last_name || worker.lastName;
    this.profileImage = worker.profile_image || worker.profileImage;
    this.role = extractRole(worker);
    this.acceptedServices = mapServices(
      worker.accepted_services || worker.acceptedServices
    );
    this.inProgressServices = mapServices(
      worker.in_progress_services || worker.inProgressServices
    );
    this.pausedServices = mapServices(
      worker.paused_services || worker.pausedServices
    );
    this.finishedServices = mapServices(
      worker.finished_services || worker.finishedServices
    );
    this.canceledServices = mapServices(
      worker.canceled_services || worker.canceledServices
    );
  }
}
